<div class="flex">
  <div class="flex">
    <div
      class="flex items-center gap-4 rounded-xl w-max px-4 py-1"
      [ngClass]="{ 'bg-primary-300': i === currentStepIndex }"
      *ngFor="let step of steps; let i = index"
      (click)="setActiveStep(i)"
    >
      <span>{{ i + 1 }}. {{ step.title }}</span>
      <onafriq-icon
        [icon]="'chevron-right'"
        [size]="'sm'"
        [color]="'gray-800'"
        class="mt-[3px]"
      />
    </div>
  </div>
</div>
